export default __webpack_public_path__ + "e6ced1806c4211cc799c7d19b1de2c59.png";